module.exports = __webpack_public_path__ + "static/media/lg_flyer.f2e2f5ed.png";